import React from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * The confirmation before a Manager deletes a sport, team, auction or contest (#307). Each page used
 * to type its own on ModalDelete: "Are you want to delete the sport?" with no name, a plural title
 * ("Delete Sports"), and "Close" where every other form says "Cancel".
 *
 * The buttons are Cancel, then Delete, on the right, as on every form (FormActions, #309). Esc and
 * the backdrop cancel too; Contest's dialog had no onHide, so neither closed it.
 *
 * @param {object} props
 * @param {boolean} props.show Whether the dialog is open.
 * @param {string} props.entity What is deleted, in lower case: "sport", "team", "auction", "contest".
 * @param {string} [props.name] The item's name, quoted in the question.
 * @param {() => void} props.onConfirm Called by Delete.
 * @param {() => void} props.onCancel Called by Cancel, Esc and the backdrop.
 */
export const ConfirmDeleteModal = ({ show, entity, name, onConfirm, onCancel }) => {
  const title = `Delete ${entity.charAt(0).toUpperCase()}${entity.slice(1)}`;
  const question = name
    ? `Are you sure you want to delete the ${entity} "${name}"?`
    : `Are you sure you want to delete this ${entity}?`;

  return (
    <Modal size="sm" show={show} onHide={onCancel} centered>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">{question}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
